/*
 * @Description: 公共的接口
 * @Author: YuKi
 * @Date: 2023-11-20 11:13:46
 */
import config from '@/config';
import http from '@/utils/http';
import * as Types from './types';
import { convertLanguageLists } from './utils';

const { languageList } = config;

/** 过滤国家列表中级别为0的国家 */
function filterCountryListByLevel<T extends { countryList: Array<{ countryLevel: number }> }>(data: T[]): T[] {
  return data.map((item) => ({
    ...item,
    countryList: item.countryList.filter((country) => country.countryLevel !== 0),
  }));
}

export default {
  /**
   * @Author: YuKi
   * @description: 获取国家列表
   * @return {*}
   */
  async getCountryList() {
    return await http.get<Types.ICountryItem[]>({ url: '/stable/user/getCountry' });
  },
  /**
   * @Author: Long Wang
   * @description: 获取菜单列表
   * @return {*}
   */
  async getMenuList(params: { countryCode: string }) {
    return await http.get<Types.IMenuListItem[]>({ url: '/osc/home/menuTree', params });
  },
  /**
   * @Author: Long Wang
   * @description: 获取头部大区及国家列表
   * @return {*}
   */
  async getRegionCountryList(isFilter: boolean = false) {
    const data = await http.get<Types.IRegionCountryListItem[]>({ url: '/osc/home/regionList', params: { countryType: 'COUNTRY' } });
    const transformedData = convertLanguageLists(data, languageList);

    return isFilter ? filterCountryListByLevel(transformedData) : transformedData;
  },
  /**
   * @Author: YuKi
   * @description: 文件下载Get方式
   */
  async fileDownloadGet(params: Types.IFileDownloadParams, fileName?: string, download?: boolean) {
    return await http.exportFileGet({ url: '/base/fileOperation/fileDownload', params: params, headers: { Accept: '*/*' } }, fileName, download);
  },

  /**
   * @Author: Stephen
   * @description: 埋点
   * @param {Types} data
   * @return {*}
   */
  async tracking(data: Types.ITrackingParams) {
    return await http.post({ url: '/osc/event/tracking', data, fullData: true });
  },
};
